import getCurrentDateTime from "../../objects/CommonUse/get_current_date_time";
import checkIfDateTimeCurrent from "../../components/login-related/objects/check_if_date_time_current";
import appRoutes from "../../datasets/app_routes";

export const updateSessionTokenStorage = (selectedValue, validate) => {
    if (!validate){
        validate = false;
    }
    let pathName = selectedValue;
    if (selectedValue !== ""){
        const path = appRoutes.find(route => route.selected === selectedValue).path;
        const pathLength = path.length;
        pathName = path.substring(1,pathLength);
    }
    const authTokenObj = JSON.parse(sessionStorage.getItem('sessionToken'));
    let tokenIsValid = false;
    if (authTokenObj){
        let newAuthToken = JSON.parse(JSON.stringify(authTokenObj));
        const checkDate = newAuthToken.dateTime;
        const currentDateTime = getCurrentDateTime();
        if (validate === true){
            tokenIsValid = checkIfDateTimeCurrent(checkDate, currentDateTime.dateTime);
        }  
        newAuthToken.dateTime = currentDateTime.dateTime;
        newAuthToken.process = pathName;
        sessionStorage.setItem('sessionToken', JSON.stringify(newAuthToken));
    }else{
        console.log("authToken not found");
    }
    if (validate === true){
    const returnObj = {authTokenObj: authTokenObj, tokenIsValid: tokenIsValid}
    return returnObj;
    }
}
export default updateSessionTokenStorage;